module.exports = __webpack_public_path__ + "img/close_hint.edaf5d2b.svg";